

/* BEGIN field-tech-shoulder-bag-buyer-highlights-20260731 */
;(function () {
  var expected = ["An adjustable, removable extra-thick shoulder pad, strap-length buckle, durable D-ring, and top handle provide flexible carrying options.","Water-resistant 900D polyester, MOLLE webbing, hook-and-loop exterior pockets, and a patch area support durable, expandable organization and personalization.","A rear hook-and-loop compartment stores a tablet or laptop up to 14.1 inches."];
  function applyBuyerHighlights() {
    if (window.location.pathname.indexOf('/products/seibertron-field-tech-shoulder-bag-tactical-response-laptop-attache-case') === -1) return;
    var box = document.querySelector('.auto-product__buyer-fit');
    if (!box) return;
    var items = box.querySelectorAll('li');
    if (items.length < 3) return;
    for (var i = 0; i < 3; i += 1) { if (items[i].textContent !== expected[i]) items[i].textContent = expected[i]; }
  }
  applyBuyerHighlights();
  [80, 250, 800, 1800, 4000].forEach(function (delay) { window.setTimeout(applyBuyerHighlights, delay); });
  new MutationObserver(applyBuyerHighlights).observe(document.documentElement, { childList: true, subtree: true });
})();
/* END field-tech-shoulder-bag-buyer-highlights-20260731 */
